import { type MouseEventHandler } from 'react';
import * as icons from '../icon/assets';
import { Icon } from '../icon/icon';

interface PopoverListProps {
  text: string;
  icon?: keyof typeof icons;
  color?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export function PopoverList({ text, icon, color = '#000', onClick }: PopoverListProps) {
  return (
    <div
      onClick={onClick}
      className='flex items-center gap-1 min-w-[184px] px-2 py-1.5 cursor-pointer hover:bg-[#0000000D] active:bg-[#0000001A] rounded-[8px]'
    >
      {icon && <Icon name={icon} size={20} color={color} />}
      <div
        className='truncate text-sm font-normal leading-5 space tracking-[-0.1px]'
        style={{ color }}
      >
        {text}
      </div>
    </div>
  );
}
